// Auto-generated from Excel - DO NOT EDIT MANUALLY
// Generated: 2025-10-13T10:29:04.222Z
// Total products: 239

export interface Product {
  id: string;
  code: string;
  name: string;
  price: string;
  material: string;
  packing: string;
  dimensions: string;
  picture: string;
  package: string;
  capacity: string;
  category: string;
}

export const catalogueData: Product[] = [
  {
    "id": "product-001",
    "code": "SP-KBX11",
    "name": "#1 Kraft Folded Takeout Box 26 fl oz Capacity",
    "price": "38.92",
    "material": "Coated Paper",
    "packing": "450pcs/ctn",
    "dimensions": "4-3/8 x 3.5 x 2.5''",
    "picture": "SP-KBX11.png",
    "package": "",
    "capacity": "",
    "category": "KRAFT FOLDED TAKEOUT BOX"
  },
  {
    "id": "product-002",
    "code": "SP-KBX88",
    "name": "#8 Kraft Folded Takeout Box 45 fl oz Capacity",
    "price": "34.84",
    "material": "Coated Paper",
    "packing": "300pcs/ctn",
    "dimensions": "6\" x 4 5/8\" x 2\r\n1/2\"",
    "picture": "SP-KBX88.png",
    "package": "",
    "capacity": "",
    "category": "KRAFT FOLDED TAKEOUT BOX"
  },
  {
    "id": "product-003",
    "code": "SP-KBX22",
    "name": "#2 Kraft Folded Takeout Box 49 fl oz Capacity",
    "price": "30.52",
    "material": "Coated Paper",
    "packing": "200pcs/ctn",
    "dimensions": "7 3/4\" x 5 1/2\"\r\nx 2\"",
    "picture": "SP-KBX22.png",
    "package": "",
    "capacity": "",
    "category": "KRAFT FOLDED TAKEOUT BOX"
  },
  {
    "id": "product-004",
    "code": "SP-KBX33",
    "name": "#3 Kraft Folded Takeout Box 66 fl oz Capacity",
    "price": "30.98",
    "material": "Coated Paper",
    "packing": "200pcs/ctn",
    "dimensions": "7 3/4\" x 5 1/2\"\r\nx 2 1/2\"",
    "picture": "SP-KBX33.png",
    "package": "",
    "capacity": "",
    "category": "KRAFT FOLDED TAKEOUT BOX"
  },
  {
    "id": "product-005",
    "code": "SP-KBX44",
    "name": "#4 Kraft Folded Takeout Box 96 fl oz Capacity",
    "price": "30.17",
    "material": "Coated Paper",
    "packing": "160pcs/ctn",
    "dimensions": "7 7/8\" x 5 1/2\"\r\nx 3 1/2\"",
    "picture": "SP-KBX44.png",
    "package": "",
    "capacity": "",
    "category": "KRAFT FOLDED TAKEOUT BOX"
  },
  {
    "id": "product-006",
    "code": "SP-FD6P",
    "name": "Paper Take Out 6x6’’ Clamshell",
    "price": "40.87",
    "material": "Kraft Paper",
    "packing": "350pcs/ctn",
    "dimensions": "6x6x3.5''",
    "picture": "SP-FD6P.png",
    "package": "",
    "capacity": "",
    "category": "CLAMSHELL TAKE-OUT BOX"
  },
  {
    "id": "product-007",
    "code": "SP- FT#HDG",
    "name": "Hot Dog Eco-Kraft Food Paper Tray  - 1000 ct",
    "price": "31.21",
    "material": "Kraft Paper",
    "packing": "1000",
    "dimensions": "7.x3.4x1.5''",
    "picture": "SP- FT#HDG.png",
    "package": "",
    "capacity": "",
    "category": "KRAFT FOOD TRAY"
  },
  {
    "id": "product-008",
    "code": "SP-FT#15",
    "name": "#50 1/2lb. Eco-Kraft Food Paper Tray - 1000 ct",
    "price": "20.19",
    "material": "Kraft Paper",
    "packing": "1000",
    "dimensions": "6.5x4.4x1.5''",
    "picture": "SP-FT#15.png",
    "package": "",
    "capacity": "",
    "category": "KRAFT FOOD TRAY"
  },
  {
    "id": "product-009",
    "code": "SP-FT#1",
    "name": "#100 1lb. Eco-Kraft Food PaperTray - 1000 ct",
    "price": "23.04",
    "material": "Kraft Paper",
    "packing": "1000",
    "dimensions": "6.5x4.8x1.8''",
    "picture": "SP-FT#1.png",
    "package": "",
    "capacity": "",
    "category": "KRAFT FOOD TRAY"
  },
  {
    "id": "product-010",
    "code": "SP-FT#2",
    "name": "#200 2lb. Eco-Kraft Food PaperTray - 1000 ct",
    "price": "30.34",
    "material": "Kraft Paper",
    "packing": "1000",
    "dimensions": "8.15x3.8x2.15''",
    "picture": "SP-FT#2.png",
    "package": "",
    "capacity": "",
    "category": "KRAFT FOOD TRAY"
  },
  {
    "id": "product-011",
    "code": "SP-FT#25",
    "name": "#250 2.5lb. Eco-Kraft Food PaperTray - 500 ct",
    "price": "19.64",
    "material": "Kraft Paper",
    "packing": "500",
    "dimensions": "7.25x5.25x1.85''",
    "picture": "SP-FT#25.png",
    "package": "",
    "capacity": "",
    "category": "KRAFT FOOD TRAY"
  },
  {
    "id": "product-012",
    "code": "SP-FT#3",
    "name": "#300 3lb. Eco-Kraft Food PaperTray - 500 ct",
    "price": "23.59",
    "material": "Kraft Paper",
    "packing": "500",
    "dimensions": "8.15x5.85x2x15' '",
    "picture": "SP-FT#3.png",
    "package": "",
    "capacity": "",
    "category": "KRAFT FOOD TRAY"
  },
  {
    "id": "product-013",
    "code": "SP-FT#5",
    "name": "#500 5 lb.Eco-Kraft Food PaperTray - 500 ct",
    "price": "26.44",
    "material": "Kraft Paper",
    "packing": "500",
    "dimensions": "9.55.6.4x2.15''",
    "picture": "SP-FT#5.png",
    "package": "",
    "capacity": "",
    "category": "KRAFT FOOD TRAY"
  },
  {
    "id": "product-014",
    "code": "SP-661W",
    "name": "6\"x6\" Mineral-Filled Take-Out Clamshell White",
    "price": "23.61",
    "material": "PP",
    "packing": "250",
    "dimensions": "6x6x3.5''",
    "picture": "SP-661W.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER CLAMSHELLS"
  },
  {
    "id": "product-015",
    "code": "SP-961W",
    "name": "9\"x6\" Mineral-Filled Take-Out Clamshell White",
    "price": "27.67",
    "material": "PP",
    "packing": "200",
    "dimensions": "9x6x3.5''",
    "picture": "SP-961W.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER CLAMSHELLS"
  },
  {
    "id": "product-016",
    "code": "SP-881W",
    "name": "8\"x8\" Mineral-Filled Take-Out Clamshell White",
    "price": "24.49",
    "material": "PP",
    "packing": "150",
    "dimensions": "8x8x3.5''",
    "picture": "SP-881W.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER CLAMSHELLS"
  },
  {
    "id": "product-017",
    "code": "SP-883W",
    "name": "8\"x8\" 3-C Mineral-Filled Take- Out Clamshell White",
    "price": "24.49",
    "material": "PP",
    "packing": "150",
    "dimensions": "8x8x3.5''",
    "picture": "SP-883W.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER CLAMSHELLS"
  },
  {
    "id": "product-018",
    "code": "SP-991W",
    "name": "9\"x9\" Mineral-Filled Take-Out Clamshell White",
    "price": "28.9",
    "material": "PP",
    "packing": "150",
    "dimensions": "9x9x3.5''",
    "picture": "SP-991W.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER CLAMSHELLS"
  },
  {
    "id": "product-019",
    "code": "SP-993W",
    "name": "9\"x9\" 3-C Mineral-Filled Take- Out\r\nClamshell White",
    "price": "28.9",
    "material": "PP",
    "packing": "150",
    "dimensions": "9x9x3.5''",
    "picture": "SP-993W.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER CLAMSHELLS"
  },
  {
    "id": "product-020",
    "code": "CHPM661 B",
    "name": "6\"x6\" Mineral-Filled Take-Out Clamshell Black",
    "price": "23.61",
    "material": "PP",
    "packing": "250",
    "dimensions": "6x6x3.5''",
    "picture": "CHPM661 B.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER CLAMSHELLS"
  },
  {
    "id": "product-021",
    "code": "CHPM961 B",
    "name": "9\"x6\" Mineral-Filled Take-Out Clamshell Black",
    "price": "28.25",
    "material": "PP",
    "packing": "200",
    "dimensions": "9x6x3.5''",
    "picture": "CHPM961 B.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER CLAMSHELLS"
  },
  {
    "id": "product-022",
    "code": "CHPM881 B",
    "name": "8\"x8\" Mineral-Filled Take-Out Clamshell Black",
    "price": "23.61",
    "material": "PP",
    "packing": "150",
    "dimensions": "8x8x3.5''",
    "picture": "CHPM881 B.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER CLAMSHELLS"
  },
  {
    "id": "product-023",
    "code": "CHPM883 B",
    "name": "8\"x8\" 3-C Mineral-Filled Take- Out Clamshell  Black",
    "price": "23.61",
    "material": "PP",
    "packing": "150",
    "dimensions": "8x8x3.5''",
    "picture": "CHPM883 B.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER CLAMSHELLS"
  },
  {
    "id": "product-024",
    "code": "CHPM991 B",
    "name": "9\"x9\" Mineral-Filled Take-Out Clamshell Black",
    "price": "27.31",
    "material": "PP",
    "packing": "150",
    "dimensions": "9x9x3.5''",
    "picture": "CHPM991 B.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER CLAMSHELLS"
  },
  {
    "id": "product-025",
    "code": "CHPM993 B",
    "name": "9\"x9\" 3-C Mineral-Filled Take- Out\r\nClamshell Black",
    "price": "27.31",
    "material": "PP",
    "packing": "150",
    "dimensions": "9x9x3.5''",
    "picture": "CHPM993 B.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER CLAMSHELLS"
  },
  {
    "id": "product-026",
    "code": "PHPM71W",
    "name": "7’’  Round Mineral-Filled Plate – White",
    "price": "19.29",
    "material": "PP",
    "packing": "400pcs/ctn",
    "dimensions": "7''",
    "picture": "PHPM71W.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER  PLATES"
  },
  {
    "id": "product-027",
    "code": "PHPM91W",
    "name": "9’’  Round Mineral-Filled Plate – White",
    "price": "27.86",
    "material": "PP",
    "packing": "400pcs/ctn",
    "dimensions": "9\"",
    "picture": "PHPM91W.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER  PLATES"
  },
  {
    "id": "product-028",
    "code": "PHPM93W",
    "name": "9’’ 3-Comp Round Mineral-Filled Plate – White",
    "price": "27.86",
    "material": "PP",
    "packing": "400pcs/ctn",
    "dimensions": "9\"",
    "picture": "PHPM93W.png",
    "package": "",
    "capacity": "",
    "category": "MINERAL POWDER  PLATES"
  },
  {
    "id": "product-029",
    "code": "BC16",
    "name": "16 oz. Black Round Heavy Weight Container with Lid",
    "price": "21.23",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": "6.05\" x 2\"",
    "picture": "BC16.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-030",
    "code": "BC24",
    "name": "24 oz. Black Round Heavy Weight Container with Lid",
    "price": "25.11",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": "7.05\" x 2\"",
    "picture": "BC24.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-031",
    "code": "BC32",
    "name": "32 oz. Black Round Heavy Weight Container with Lid",
    "price": "26.71",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": "7.05\" x 2.25\"",
    "picture": "BC32.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-032",
    "code": "BC36",
    "name": "36 oz. Black Round Heavy Weight Container with Lid",
    "price": "34.29",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": "7.05\" x 3.05\"",
    "picture": "BC36.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-033",
    "code": "BC48",
    "name": "48 oz. Black Round Heavy Weight Container with Lid",
    "price": "39.14",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": "9'' x 2.05\"",
    "picture": "BC48.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-034",
    "code": "BR12",
    "name": "12 oz. Black Rectangular Heavy Weight Container with Lid",
    "price": "18.2",
    "material": "PP",
    "packing": "151 Combo",
    "dimensions": "6\" x 4.75\" x 1.8\"",
    "picture": "BR12.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-035",
    "code": "BR16",
    "name": "16 oz. Black Rectangular Heavy Weight Container with Lid",
    "price": "21.4",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": "8\" x 5.27\" x 2\"",
    "picture": "BR16.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-036",
    "code": "BR24",
    "name": "24 oz. Black Rectangular Heavy Weight Container with Lid",
    "price": "24.15",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": ".50\" x 6\" x 1.30",
    "picture": "BR24.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-037",
    "code": "BR28",
    "name": "28 oz. Black Rectangular Heavy Weight Container with Lid",
    "price": "27.01",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": ".50\" x 6\" x 2.05",
    "picture": "BR28.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-038",
    "code": "BR32",
    "name": "32 oz. Black Rectangular Heavy Weight Container with Lid",
    "price": "27.56",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": ".50\" x 6\" x 2.10",
    "picture": "BR32.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-039",
    "code": "BR38",
    "name": "38 oz. Black Rectangular Heavy Weight Container with Lid",
    "price": "32.58",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": ".75\" x 6.25\" x 2",
    "picture": "BR38.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-040",
    "code": "BR58",
    "name": "58 oz. Black Rectangular Heavy Weight Container with Lid",
    "price": "47.14",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": "11\"X8X3.25\"",
    "picture": "BR58.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-041",
    "code": "BR32C2",
    "name": "2 Compartment 32 oz. Black Rectangular Container with Lid",
    "price": "32.86",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": ".50\" x 6\" x 2.10\"",
    "picture": "BR32C2.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-042",
    "code": "BR36C3",
    "name": "3 Compartment 36 oz. Black Rectangular Container with Lid",
    "price": "70.29",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": "9\" x 7.30\" x 2\"",
    "picture": "BR36C3.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-043",
    "code": "BSQ40",
    "name": "48oz Black Square Heavy Duty Weight Container with Lid",
    "price": "47.53",
    "material": "PP",
    "packing": "150 Combo",
    "dimensions": "21x21x5",
    "picture": "BSQ40.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-044",
    "code": "BQ4830",
    "name": "48oz 3-Comp Black Square Heavy Duty Container with Lid",
    "price": "38.98",
    "material": "PP",
    "packing": "100 Combo",
    "dimensions": "21x21x5",
    "picture": "BQ4830.png",
    "package": "",
    "capacity": "",
    "category": "BLACK PLASTIC CONTAINERS"
  },
  {
    "id": "product-045",
    "code": "SP -S- 1101",
    "name": "XS Black Sushi Tray and Clear Lid",
    "price": "42.42",
    "material": "PP",
    "packing": "400 Set",
    "dimensions": "6.50''x3.60''x0.8''",
    "picture": "SP -S- 1101.png",
    "package": "",
    "capacity": "",
    "category": "BLACK SUSHI  TRAYS"
  },
  {
    "id": "product-046",
    "code": "SP -S- 1102",
    "name": "Small Black Sushi Tray and Clear Lid",
    "price": "50.18",
    "material": "PP",
    "packing": "400 Set",
    "dimensions": "8.60''x3.60''x0.8''",
    "picture": "SP -S- 1102.png",
    "package": "",
    "capacity": "",
    "category": "BLACK SUSHI  TRAYS"
  },
  {
    "id": "product-047",
    "code": "SP -S- 1103",
    "name": "Regular Black Sushi Tray and Clear Lid",
    "price": "46.65",
    "material": "PP",
    "packing": "400 Set",
    "dimensions": "6''x4.00''x0.70''",
    "picture": "SP -S- 1103.png",
    "package": "",
    "capacity": "",
    "category": "BLACK SUSHI  TRAYS"
  },
  {
    "id": "product-048",
    "code": "SP -S-1105",
    "name": "Medium Black Sushi Tray and Clear Lid",
    "price": "58.64",
    "material": "PP",
    "packing": "400 Set",
    "dimensions": "7.10' x 5 x 0.70",
    "picture": "SP -S-1105.png",
    "package": "",
    "capacity": "",
    "category": "BLACK SUSHI  TRAYS"
  },
  {
    "id": "product-049",
    "code": "SP -S-1107",
    "name": "Large Black Sushi Tray and Clear Lid",
    "price": "72.74",
    "material": "PP",
    "packing": "400 Set",
    "dimensions": "8.5 x 5.30 x0.9",
    "picture": "SP -S-1107.png",
    "package": "",
    "capacity": "",
    "category": "BLACK SUSHI  TRAYS"
  },
  {
    "id": "product-050",
    "code": "W-81",
    "name": "8x8’’ PP Black Tray with Translucent Lid – Not Hinged",
    "price": "27.72",
    "material": "PP",
    "packing": "100 set",
    "dimensions": "8x8x3.5''",
    "picture": "W-81.png",
    "package": "",
    "capacity": "",
    "category": "DUAL COLOR BLACK CONTAINERS"
  },
  {
    "id": "product-051",
    "code": "W-91",
    "name": "9x9’’ PP Black Tray with Translucent Lid – Not Hinged",
    "price": "33.45",
    "material": "PP",
    "packing": "100 set",
    "dimensions": "9x9x3.5''",
    "picture": "W-91.png",
    "package": "",
    "capacity": "",
    "category": "DUAL COLOR BLACK CONTAINERS"
  },
  {
    "id": "product-052",
    "code": "TH-6X6",
    "name": "6\"x6\" Black/Clear Take-Out Clamshell",
    "price": "36.89",
    "material": "PP",
    "packing": "300",
    "dimensions": "6x6x3.5''",
    "picture": "TH-6X6.png",
    "package": "",
    "capacity": "",
    "category": "DUAL COLOR BLACK/CLEAR CLAMSHELLS"
  },
  {
    "id": "product-053",
    "code": "TH-9X6",
    "name": "9\"x6\" Black/Clear Take-Out Clamshell",
    "price": "31.17",
    "material": "PP",
    "packing": "150",
    "dimensions": "9x6x3.5''",
    "picture": "TH-9X6.png",
    "package": "",
    "capacity": "",
    "category": "DUAL COLOR BLACK/CLEAR CLAMSHELLS"
  },
  {
    "id": "product-054",
    "code": "ML-BW81",
    "name": "8\"x8\" Black/Clear Take-Out Clamshell",
    "price": "36.25",
    "material": "PP",
    "packing": "150",
    "dimensions": "8x8x3.5''",
    "picture": "ML-BW81.png",
    "package": "",
    "capacity": "",
    "category": "DUAL COLOR BLACK/CLEAR CLAMSHELLS"
  },
  {
    "id": "product-055",
    "code": "ML-BW83",
    "name": "8\"x8\" 3-Compartment Black/Clear Take-Out Clamshell",
    "price": "36.25",
    "material": "PP",
    "packing": "150",
    "dimensions": "8x8x3.5''",
    "picture": "ML-BW83.png",
    "package": "",
    "capacity": "",
    "category": "DUAL COLOR BLACK/CLEAR CLAMSHELLS"
  },
  {
    "id": "product-056",
    "code": "ML-BW91",
    "name": "9\"x9\" Black/Clear Take-Out Clamshell",
    "price": "42.6",
    "material": "PP",
    "packing": "150",
    "dimensions": "9x9x3.5''",
    "picture": "ML-BW91.png",
    "package": "",
    "capacity": "",
    "category": "DUAL COLOR BLACK/CLEAR CLAMSHELLS"
  },
  {
    "id": "product-057",
    "code": "ML- BW93",
    "name": "9\"x9\" 3-Compartment Black/Clear Take-Out Clamshell",
    "price": "42.6",
    "material": "PP",
    "packing": "150",
    "dimensions": "9x9x3.5''",
    "picture": "ML- BW93.png",
    "package": "",
    "capacity": "",
    "category": "DUAL COLOR BLACK/CLEAR CLAMSHELLS"
  },
  {
    "id": "product-058",
    "code": "SP-PS-05",
    "name": "Clear Hinged Take-Out Containers 5x5''",
    "price": "42.93",
    "material": "PS",
    "packing": "500",
    "dimensions": "5x5x3''",
    "picture": "SP-PS-05.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR CLAMSHELL"
  },
  {
    "id": "product-059",
    "code": "SP-PS-06",
    "name": "Clear Hinged Take-Out Containers 6x6''",
    "price": "53.24",
    "material": "PS",
    "packing": "500",
    "dimensions": "6x6x3.5''",
    "picture": "SP-PS-06.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR CLAMSHELL"
  },
  {
    "id": "product-060",
    "code": "SP-PS- 955",
    "name": "Clear Hinged Take-Out Containers 9x5''",
    "price": "104.98",
    "material": "PS",
    "packing": "600",
    "dimensions": "9x5x3.5''",
    "picture": "SP-PS- 955.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR CLAMSHELL"
  },
  {
    "id": "product-061",
    "code": "SP-PS- 088",
    "name": "Clear Hinged Take-Out Container 8x8''",
    "price": "49.75",
    "material": "PS",
    "packing": "250",
    "dimensions": "8x8x3''",
    "picture": "SP-PS- 088.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR CLAMSHELL"
  },
  {
    "id": "product-062",
    "code": "SP-PS- 083C",
    "name": "Clear Hinged Take-Out Container 8x8'' 3 Compartment",
    "price": "49.75",
    "material": "PS",
    "packing": "250",
    "dimensions": "8x8x3''",
    "picture": "SP-PS- 083C.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR CLAMSHELL"
  },
  {
    "id": "product-063",
    "code": "SP-PS- 099",
    "name": "Clear Hinged Take-Out Containers 9x9''",
    "price": "50.97",
    "material": "PS",
    "packing": "200",
    "dimensions": "9x9x3''",
    "picture": "SP-PS- 099.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR CLAMSHELL"
  },
  {
    "id": "product-064",
    "code": "SP-PS- 093X",
    "name": "Clear Hinged Take-Out Container 9x9'' 3 Compartment",
    "price": "50.97",
    "material": "PS",
    "packing": "200",
    "dimensions": "9x9x3''",
    "picture": "SP-PS- 093X.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR CLAMSHELL"
  },
  {
    "id": "product-065",
    "code": "V-61C",
    "name": "6x 6\" Translucid Clamshell",
    "price": "29.99",
    "material": "PP",
    "packing": "250",
    "dimensions": "6x6x3.5''",
    "picture": "V-61C.png",
    "package": "",
    "capacity": "",
    "category": "TRANSLUCID PP CLAMSHELL"
  },
  {
    "id": "product-066",
    "code": "V-96C",
    "name": "9x 6\" Translucid Clamshell",
    "price": "36.39",
    "material": "PP",
    "packing": "200",
    "dimensions": "9x6x3.5''",
    "picture": "V-96C.png",
    "package": "",
    "capacity": "",
    "category": "TRANSLUCID PP CLAMSHELL"
  },
  {
    "id": "product-067",
    "code": "V-81C",
    "name": "8\" x 8\" Translucid Clamshell",
    "price": "29.99",
    "material": "PP",
    "packing": "150",
    "dimensions": "8x8x3''",
    "picture": "V-81C.png",
    "package": "",
    "capacity": "",
    "category": "TRANSLUCID PP CLAMSHELL"
  },
  {
    "id": "product-068",
    "code": "V-83C",
    "name": "8\" x 8\" 3-Comp Translucid Clamshell",
    "price": "29.99",
    "material": "PP",
    "packing": "150",
    "dimensions": "8x8x3''",
    "picture": "V-83C.png",
    "package": "",
    "capacity": "",
    "category": "TRANSLUCID PP CLAMSHELL"
  },
  {
    "id": "product-069",
    "code": "V-91C",
    "name": "9\" x 9\" Translucid Clamshell",
    "price": "35.23",
    "material": "PP",
    "packing": "150",
    "dimensions": "9x9x3''",
    "picture": "V-91C.png",
    "package": "",
    "capacity": "",
    "category": "TRANSLUCID PP CLAMSHELL"
  },
  {
    "id": "product-070",
    "code": "V-93C",
    "name": "9\" x 9\" 3-Comp Translucid Clamshell",
    "price": "35.23",
    "material": "PP",
    "packing": "150",
    "dimensions": "9x9x3''",
    "picture": "V-93C.png",
    "package": "",
    "capacity": "",
    "category": "TRANSLUCID PP CLAMSHELL"
  },
  {
    "id": "product-071",
    "code": "08EVIDEN",
    "name": "8 oz Tamper Evident Hinged Container with Flat Lid",
    "price": "31.39",
    "material": "PET",
    "packing": "200 pcs",
    "dimensions": "5.5x5.1x1.5''",
    "picture": "08EVIDEN.png",
    "package": "",
    "capacity": "",
    "category": "TAMPER-EVIDENT HINGED CONTAINER"
  },
  {
    "id": "product-072",
    "code": "16EVIDEN",
    "name": "16 oz Tamper Evident Hinged Container with Flat Lid",
    "price": "34.56",
    "material": "PET",
    "packing": "200 pcs",
    "dimensions": "5.5x5.1x2.5’'",
    "picture": "16EVIDEN.png",
    "package": "",
    "capacity": "",
    "category": "TAMPER-EVIDENT HINGED CONTAINER"
  },
  {
    "id": "product-073",
    "code": "20EVIDENT",
    "name": "20 oz Tamper Evident Hinged Container with Flat Lid",
    "price": "44.61",
    "material": "PET",
    "packing": "200 pcs",
    "dimensions": "7.3x5.7x1.8'",
    "picture": "20EVIDEN\r\nT.png",
    "package": "",
    "capacity": "",
    "category": "TAMPER-EVIDENT HINGED CONTAINER"
  },
  {
    "id": "product-074",
    "code": "24EVIDENT",
    "name": "24 oz Tamper Evident Hinged Container with Flat Lid",
    "price": "45.31",
    "material": "PET",
    "packing": "200 pcs",
    "dimensions": "7x5.7x2’’",
    "picture": "24EVIDEN\r\nT.png",
    "package": "",
    "capacity": "",
    "category": "TAMPER-EVIDENT HINGED CONTAINER"
  },
  {
    "id": "product-075",
    "code": "32EVIDEN",
    "name": "32 oz Tamper Evident Hinged Container with Flat Lid",
    "price": "53.07",
    "material": "PET",
    "packing": "200 pcs",
    "dimensions": "7.4x5.7x2.8 ’’",
    "picture": "32EVIDEN.png",
    "package": "",
    "capacity": "",
    "category": "TAMPER-EVIDENT HINGED CONTAINER"
  },
  {
    "id": "product-076",
    "code": "35EVIDENT",
    "name": "35 oz Tamper Evident Hinged Container with Flat Lid",
    "price": "50.78",
    "material": "PET",
    "packing": "150 pcs",
    "dimensions": "9x8x1.8''",
    "picture": "35EVIDEN\r\nT.png",
    "package": "",
    "capacity": "",
    "category": "TAMPER-EVIDENT HINGED CONTAINER"
  },
  {
    "id": "product-077",
    "code": "DH-08",
    "name": "8oz PP Deli Container Base",
    "price": "22.46",
    "material": "PP",
    "packing": "500pc/cnt",
    "dimensions": "",
    "picture": "DH-08.png",
    "package": "",
    "capacity": "",
    "category": "PLASTIC DELI CONTAINER"
  },
  {
    "id": "product-078",
    "code": "DH-12",
    "name": "12oz PP Deli Container Base",
    "price": "25.42",
    "material": "PP",
    "packing": "500pc/cnt",
    "dimensions": "",
    "picture": "DH-12.png",
    "package": "",
    "capacity": "",
    "category": "PLASTIC DELI CONTAINER"
  },
  {
    "id": "product-079",
    "code": "DH-16",
    "name": "16oz PP Deli Container Base",
    "price": "30.39",
    "material": "PP",
    "packing": "500pc/cnt",
    "dimensions": "",
    "picture": "DH-16.png",
    "package": "",
    "capacity": "",
    "category": "PLASTIC DELI CONTAINER"
  },
  {
    "id": "product-080",
    "code": "DH-32",
    "name": "32oz PP Deli Container Base",
    "price": "49.79",
    "material": "PP",
    "packing": "500pc/cnt",
    "dimensions": "",
    "picture": "DH-32.png",
    "package": "",
    "capacity": "",
    "category": "PLASTIC DELI CONTAINER"
  },
  {
    "id": "product-081",
    "code": "DH-LID",
    "name": "Lids for 8-32oz Deli Container",
    "price": "25.11",
    "material": "PP",
    "packing": "500pc/cnt",
    "dimensions": "",
    "picture": "DH-LID.png",
    "package": "",
    "capacity": "",
    "category": "PLASTIC DELI CONTAINER"
  },
  {
    "id": "product-082",
    "code": "DCHPP850",
    "name": "8oz Clear Deli Container Lightweight",
    "price": "21.19",
    "material": "PP",
    "packing": "500pc/cnt",
    "dimensions": "",
    "picture": "DCHPP85\r\n0.png",
    "package": "",
    "capacity": "",
    "category": "PLASTIC DELI CONTAINER"
  },
  {
    "id": "product-083",
    "code": "DCHPP1250",
    "name": "12oz Clear Deli Container Lightweight",
    "price": "24.01",
    "material": "PP",
    "packing": "500pc/cnt",
    "dimensions": "",
    "picture": "DCHPP12\r\n50.png",
    "package": "",
    "capacity": "",
    "category": "PLASTIC DELI CONTAINER"
  },
  {
    "id": "product-084",
    "code": "DCHPP1650",
    "name": "16oz Clear Deli Container Lightweight",
    "price": "25.14",
    "material": "PP",
    "packing": "500pc/cnt",
    "dimensions": "",
    "picture": "DCHPP16\r\n50.png",
    "package": "",
    "capacity": "",
    "category": "PLASTIC DELI CONTAINER"
  },
  {
    "id": "product-085",
    "code": "DCHPP32 50",
    "name": "32oz Clear Deli Container Lightweight",
    "price": "34.21",
    "material": "PP",
    "packing": "500pc/cnt",
    "dimensions": "",
    "picture": "DCHPP32 50.png",
    "package": "",
    "capacity": "",
    "category": "PLASTIC DELI CONTAINER"
  },
  {
    "id": "product-086",
    "code": "DLHPP50",
    "name": "PP Lid for 8/16/32oz Clear Deli Container Lightweight",
    "price": "16.52",
    "material": "PP",
    "packing": "500pc/cnt",
    "dimensions": "",
    "picture": "DLHPP50.png",
    "package": "",
    "capacity": "",
    "category": "PLASTIC DELI CONTAINER"
  },
  {
    "id": "product-087",
    "code": "SP- KFB1516 /KR1516",
    "name": "16oz kraft paper bowl",
    "price": "27.51",
    "material": "Paper",
    "packing": "300 pcs",
    "dimensions": "2.38\"x 5.94\"",
    "picture": "SP- KFB1516 /\r\nKR1516.png",
    "package": "",
    "capacity": "",
    "category": "PAPER KRAFT CONTAINER"
  },
  {
    "id": "product-088",
    "code": "KR1524",
    "name": "24oz kraft paper bowl",
    "price": "27.64",
    "material": "Paper",
    "packing": "300 pcs",
    "dimensions": "2.38\"x 5.94\"",
    "picture": "KR1524.png",
    "package": "",
    "capacity": "",
    "category": "PAPER KRAFT CONTAINER"
  },
  {
    "id": "product-089",
    "code": "KR1532",
    "name": "32oz kraft paper bowl",
    "price": "30.19",
    "material": "Paper",
    "packing": "300pcs",
    "dimensions": "3\"x 5.94\"",
    "picture": "KR1532.png",
    "package": "",
    "capacity": "",
    "category": "PAPER KRAFT CONTAINER"
  },
  {
    "id": "product-090",
    "code": "KR150F",
    "name": "Clear Lid for 16/24/32oz kraft paper bowl -600 pcs",
    "price": "21.12",
    "material": "PP",
    "packing": "300pcs",
    "dimensions": "6 1/8",
    "picture": "KR150F.png",
    "package": "",
    "capacity": "",
    "category": "PAPER KRAFT CONTAINER"
  },
  {
    "id": "product-091",
    "code": "KR1524",
    "name": "24oz kraft paper bowl",
    "price": "31.8",
    "material": "Paper",
    "packing": "300pcs",
    "dimensions": "2.38\"x 5.94\"",
    "picture": "KR1524.png",
    "package": "",
    "capacity": "",
    "category": "PAPER KRAFT CONTAINER"
  },
  {
    "id": "product-092",
    "code": "KR1532",
    "name": "32oz kraft paper bowl",
    "price": "33.41",
    "material": "Paper",
    "packing": "300pcs",
    "dimensions": "3\"x 5.94\"",
    "picture": "KR1532.png",
    "package": "",
    "capacity": "",
    "category": "PAPER KRAFT CONTAINER"
  },
  {
    "id": "product-093",
    "code": "KR150F",
    "name": "Clear Lid for 16/24/32oz kraft paper bowl -600 pcs",
    "price": "23.35",
    "material": "PP",
    "packing": "300pcs",
    "dimensions": "6 1/8",
    "picture": "KR150F.png",
    "package": "",
    "capacity": "",
    "category": "PAPER KRAFT CONTAINER"
  },
  {
    "id": "product-094",
    "code": "SP-PC6oz- 96",
    "name": "06oz - White/Green Paper Food Cup -96mm",
    "price": "43.41",
    "material": "Eco Paper",
    "packing": "1000",
    "dimensions": "3 1/8'' x 2 1/4''",
    "picture": "SP-PC6oz- 96.png",
    "package": "",
    "capacity": "",
    "category": "PAPER FOOD CONTAINER/PAPER SOUP CUP"
  },
  {
    "id": "product-095",
    "code": "SP-PC896",
    "name": "08oz - White/Green Paper Food Cup -96mm",
    "price": "45.73",
    "material": "Eco Paper",
    "packing": "1000",
    "dimensions": "3 1/8'' x 2 1/4''",
    "picture": "SP-PC896.png",
    "package": "",
    "capacity": "",
    "category": "PAPER FOOD CONTAINER/PAPER SOUP CUP"
  },
  {
    "id": "product-096",
    "code": "SP-PC1296",
    "name": "12oz - White/Green Paper Food Cup -112mm",
    "price": "48.04",
    "material": "Eco Paper",
    "packing": "1000",
    "dimensions": "4 3/8'' x 2 3/2''",
    "picture": "SP-PC1296.png",
    "package": "",
    "capacity": "",
    "category": "PAPER FOOD CONTAINER/PAPER SOUP CUP"
  },
  {
    "id": "product-097",
    "code": "SP- PC16112",
    "name": "16oz - White/Green Paper Food Cup -112mm",
    "price": "52.21",
    "material": "Eco Paper",
    "packing": "1000",
    "dimensions": "4 3/8'' x 2 3/4''",
    "picture": "SP- PC16112.png",
    "package": "",
    "capacity": "",
    "category": "PAPER FOOD CONTAINER/PAPER SOUP CUP"
  },
  {
    "id": "product-098",
    "code": "SP-PPL96",
    "name": "6oz/8oz/10oz Clear Hot/Cold Cup Lid -96mm",
    "price": "28.11",
    "material": "PP",
    "packing": "1000",
    "dimensions": "3 1/8'' x 0.4''",
    "picture": "SP-PPL96.png",
    "package": "",
    "capacity": "",
    "category": "PAPER FOOD CONTAINER/PAPER SOUP CUP"
  },
  {
    "id": "product-099",
    "code": "SP-PPL520",
    "name": "12oz/16oz Clear Hot/Cold Cup Lid - 112mm",
    "price": "28.73",
    "material": "PP",
    "packing": "1000",
    "dimensions": "4 3/8' x 0.4''",
    "picture": "SP-PPL520.png",
    "package": "",
    "capacity": "",
    "category": "PAPER FOOD CONTAINER/PAPER SOUP CUP"
  },
  {
    "id": "product-100",
    "code": "C-KDL116- PET",
    "name": "Dome lid with hole for 12oz/16oz Paper Food Cont - 112mm",
    "price": "14.29",
    "material": "PP",
    "packing": "1000",
    "dimensions": "4 3/8' x 0.4''",
    "picture": "C-KDL116- PET.png",
    "package": "",
    "capacity": "",
    "category": "PAPER FOOD CONTAINER/PAPER SOUP CUP"
  },
  {
    "id": "product-101",
    "code": "SHP14510 0",
    "name": "1oz Plastic Souffle Cup  PP",
    "price": "15",
    "material": "PP",
    "packing": "2500",
    "dimensions": "45 mm Rim",
    "picture": "SHP14510 0.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-102",
    "code": "LHFC145 125",
    "name": "PET CLEAR LIDS / 1oz Cup",
    "price": "13.57",
    "material": "PET",
    "packing": "2500",
    "dimensions": "45 mm Rim",
    "picture": "LHFC145 125.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-103",
    "code": "SHP15621 00",
    "name": "1.5oz Plastic Souffle Cup  PP",
    "price": "20",
    "material": "PP",
    "packing": "2500",
    "dimensions": "62 mm Rim",
    "picture": "SHP15621 00.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-104",
    "code": "SHP26210 0",
    "name": "2oz Plastic Souffle Cup  PP",
    "price": "20.71",
    "material": "PP",
    "packing": "2500",
    "dimensions": "62 mm Rim",
    "picture": "SHP26210 0.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-105",
    "code": "LHFC622 25",
    "name": "PET CLEAR LIDS / 1.5oz / 2oz Cup",
    "price": "17.86",
    "material": "PET",
    "packing": "2500",
    "dimensions": "62 mm Rim",
    "picture": "LHFC622 25.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-106",
    "code": "SHP32574 100",
    "name": "3.25oz Plastic Souffle Cup  PP",
    "price": "27.86",
    "material": "PP",
    "packing": "2500",
    "dimensions": "74 mm Rim",
    "picture": "SHP32574 100.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-107",
    "code": "SHP47410 0",
    "name": "4oz Plastic Souffle Cup  PP",
    "price": "33.57",
    "material": "PP",
    "packing": "2500",
    "dimensions": "74 mm Rim",
    "picture": "SHP47410 0.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-108",
    "code": "SHP55741 25",
    "name": "5.5oz Plastic Souffle Cup  PP",
    "price": "36.43",
    "material": "PP",
    "packing": "2500",
    "dimensions": "74 mm Rim",
    "picture": "SHP55741 25.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-109",
    "code": "LHFC743 25455",
    "name": "PET CLEAR LIDS /3.25oz/ 4oz and 5.5oz Cup",
    "price": "22.14",
    "material": "PET",
    "packing": "2500",
    "dimensions": "74 mm Rim",
    "picture": "LHFC743 25455.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-110",
    "code": "SHP26212 5B",
    "name": "2oz Plastic Souffle Cup Black",
    "price": "21.43",
    "material": "PP",
    "packing": "2500",
    "dimensions": "62 mm Rim",
    "picture": "SHP26212 5B.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-111",
    "code": "SHP47412 5B",
    "name": "4oz Plastic Souffle Cup Black",
    "price": "35",
    "material": "PP",
    "packing": "2501",
    "dimensions": "74 mm Rim",
    "picture": "SHP47412 5B.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-112",
    "code": "CP010",
    "name": "1oz Souffle Fiber Cup",
    "price": "43.03",
    "material": "Natural Pulp",
    "packing": "2000",
    "dimensions": "62 mm Rim",
    "picture": "CP010.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-113",
    "code": "CP021",
    "name": "2oz Souffle Fiber Cup",
    "price": "52.36",
    "material": "Natural Pulp",
    "packing": "2000",
    "dimensions": "62 mm Rim",
    "picture": "CP021.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-114",
    "code": "CPL022",
    "name": "Fiber Lid for 1oz and 2oz Souffle Fiber Cup",
    "price": "33.69",
    "material": "Natural Pulp",
    "packing": "2000",
    "dimensions": "62 mm Rim",
    "picture": "CPL022.png",
    "package": "",
    "capacity": "",
    "category": "PORTION/SOUFFLE CUPS"
  },
  {
    "id": "product-115",
    "code": "CHC0592",
    "name": "5oz Clear Cup For Dessert with Desing",
    "price": "45.71",
    "material": "PET",
    "packing": "1000",
    "dimensions": "92 mm Rim",
    "picture": "CHC0592.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-116",
    "code": "CHC0878 50",
    "name": "08oz Pet Cold Drink Cup",
    "price": "32.86",
    "material": "PET",
    "packing": "1000",
    "dimensions": "78 mm Rim",
    "picture": "CHC0878 50.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-117",
    "code": "CHC099250L",
    "name": "09oz Clear Cup For Dessert with Desing",
    "price": "37.14",
    "material": "PET",
    "packing": "1000",
    "dimensions": "92 mm Rim",
    "picture": "CHC0992\r\n50L.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-118",
    "code": "CHC107850",
    "name": "10oz Clear Cold Cup",
    "price": "34.29",
    "material": "PET",
    "packing": "1000",
    "dimensions": "78 mm Rim",
    "picture": "CHC1078\r\n50.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-119",
    "code": "CHC129250",
    "name": "12oz Clear Cold Cup",
    "price": "40",
    "material": "PET",
    "packing": "1000",
    "dimensions": "92 mm Rim",
    "picture": "CHC1292\r\n50.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-120",
    "code": "CHC149850",
    "name": "12/14oz Clear Cold Cup",
    "price": "41.43",
    "material": "PET",
    "packing": "1000",
    "dimensions": "98 mm Rim",
    "picture": "CHC1498\r\n50.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-121",
    "code": "CHC169850",
    "name": "16oz Clear Cold Cup",
    "price": "44.23",
    "material": "PET",
    "packing": "1000",
    "dimensions": "98 mm Rim",
    "picture": "CHC1698\r\n50.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-122",
    "code": "CHC209850",
    "name": "20oz Clear Cold Cup",
    "price": "54.29",
    "material": "PET",
    "packing": "1000",
    "dimensions": "98 mm Rim",
    "picture": "CHC2098\r\n50.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-123",
    "code": "CHC249850",
    "name": "24oz Clear Cold Cup",
    "price": "40",
    "material": "PET",
    "packing": "600",
    "dimensions": "98 mm Rim",
    "picture": "CHC2498\r\n50.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-124",
    "code": "CHC3210725-",
    "name": "32oz Clear Cold Cup 500/ctn - PET",
    "price": "45.71",
    "material": "PET",
    "packing": "500",
    "dimensions": "102 mm Rim",
    "picture": "CHC3210\r\n725-.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-125",
    "code": "310498IN",
    "name": "4 oz. PET Insert for 12/14,16,20,24oz Cup",
    "price": "42.14",
    "material": "PET",
    "packing": "1000",
    "dimensions": "98 mm Rim",
    "picture": "310498IN.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-126",
    "code": "LHFC921 00HX",
    "name": "9oz, 12oz - Clear Flat Lid with Straw Slot",
    "price": "20",
    "material": "PET",
    "packing": "1000",
    "dimensions": "92 mm Rim",
    "picture": "LHFC921 00HX.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-127",
    "code": "LHFC921 00WH",
    "name": "9oz, 12oz - Clear Flat Lid without Slot",
    "price": "20",
    "material": "PET",
    "packing": "1000",
    "dimensions": "92 mm Rim",
    "picture": "LHFC921 00WH.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-128",
    "code": "LHDC921 00HO",
    "name": "9oz, 12oz - Clear Dome Lid with Slot",
    "price": "22.86",
    "material": "PET",
    "packing": "1000",
    "dimensions": "92 mm Rim",
    "picture": "LHDC921 00HO.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-129",
    "code": "LHDC921 00WH",
    "name": "9oz, 12oz - Clear Dome Lid without Slot",
    "price": "22.86",
    "material": "PET",
    "packing": "1000",
    "dimensions": "92 mm Rim",
    "picture": "LHDC921 00WH.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-130",
    "code": "LHFC981 00HX",
    "name": "14oz, 16oz, 20oz, 24oz - Clear Flat Lid with Straw Slot",
    "price": "21.43",
    "material": "PET",
    "packing": "1000",
    "dimensions": "98 mm Rim",
    "picture": "LHFC981 00HX.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-131",
    "code": "LHFC981 00WH",
    "name": "14oz, 16oz, 20oz, 24oz - Clear Flat Lid withhout slot",
    "price": "21.43",
    "material": "PET",
    "packing": "1000",
    "dimensions": "98 mm Rim",
    "picture": "LHFC981 00WH.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-132",
    "code": "C-KC626TS- SH",
    "name": "Strawless Sipper lid for 12-24oz PET Cup",
    "price": "37.14",
    "material": "PET",
    "packing": "1000 pcs",
    "dimensions": "98 mm Rim",
    "picture": "C-\r\nKC626TS- SH.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-133",
    "code": "LHDC981 00HO",
    "name": "14oz, 16oz, 20oz, 24oz - Clear DOME  Lid with Straw Slot",
    "price": "25.71",
    "material": "PET",
    "packing": "1000",
    "dimensions": "98 mm Rim",
    "picture": "LHDC981 00HO.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-134",
    "code": "LHSDC98 100HO",
    "name": "14oz, 16oz, 20oz, 24oz - Clear SEMI DOME  Lid with Straw Slot",
    "price": "27.14",
    "material": "PET",
    "packing": "1000",
    "dimensions": "98 mm Rim",
    "picture": "LHSDC98 100HO.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-135",
    "code": "LHDC981 00WH",
    "name": "14oz, 16oz, 20oz, 24oz - Clear DOME  Lid with No Hole",
    "price": "25.71",
    "material": "PET",
    "packing": "1000",
    "dimensions": "98 mm Rim",
    "picture": "LHDC981 00WH.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-136",
    "code": "LHFC107 50HX",
    "name": "32oz - Clear Flat Lid with Straw Slot",
    "price": "15.71",
    "material": "PET",
    "packing": "500",
    "dimensions": "102 mm Rim",
    "picture": "LHFC107 50HX.png",
    "package": "",
    "capacity": "",
    "category": "CLEAR DRINKING CUPS AND LIDS"
  },
  {
    "id": "product-137",
    "code": "42CKFSK PSM.WH",
    "name": "PSM Eco Cutlery Kit FKSN - Beige Color",
    "price": "37.13",
    "material": "PSM\r\n(ECO)",
    "packing": "250/set\r\nFork,Spoon,Knife,Napkin",
    "dimensions": "",
    "picture": "42CKFSK PSM.WH.png",
    "package": "",
    "capacity": "",
    "category": "CUTLERY"
  },
  {
    "id": "product-138",
    "code": "KIT-SFK- 2POL-001",
    "name": "Agave Biodegradable Cutlery Kit F+S+K",
    "price": "75.71",
    "material": "Agave",
    "packing": "Agave Biodegradable Cutlery Kit F+S+K",
    "dimensions": "",
    "picture": "KIT-SFK- 2POL-001.png",
    "package": "",
    "capacity": "",
    "category": "CUTLERY"
  },
  {
    "id": "product-139",
    "code": "31MPH800",
    "name": "3 in 1 PP Medium Weight Kit FKN PP - WHITE",
    "price": "19.55",
    "material": "PP",
    "packing": "500/set\r\nFork,Knife,Napkin",
    "dimensions": "",
    "picture": "31MPH80\r\n0.png",
    "package": "",
    "capacity": "",
    "category": "CUTLERY"
  },
  {
    "id": "product-140",
    "code": "41MPH600",
    "name": "4 in 1 PP Medium Weight Kit FKSN PP - BLACK",
    "price": "24.24",
    "material": "PP",
    "packing": "500/set\r\nFork,Knife,Napkin",
    "dimensions": "",
    "picture": "41MPH60\r\n0.png",
    "package": "",
    "capacity": "",
    "category": "CUTLERY"
  },
  {
    "id": "product-141",
    "code": "FHPHW10 00",
    "name": "Heavy Duty Fork, Bulk - Black",
    "price": "21.3",
    "material": "PS",
    "packing": "1000pcs/ctn",
    "dimensions": "",
    "picture": "FHPHW10 00.png",
    "package": "",
    "capacity": "",
    "category": "CUTLERY"
  },
  {
    "id": "product-142",
    "code": "SHPHW10 00",
    "name": "Heavy Duty Spoon Bulk - Black",
    "price": "20.2",
    "material": "PS",
    "packing": "1000pcs/ctn",
    "dimensions": "",
    "picture": "SHPHW10 00.png",
    "package": "",
    "capacity": "",
    "category": "CUTLERY"
  },
  {
    "id": "product-143",
    "code": "KHPHW1 000",
    "name": "Heavy Duty Knife Bulk - Black",
    "price": "24.01",
    "material": "PS",
    "packing": "1000pcs/ctn",
    "dimensions": "",
    "picture": "KHPHW1 000.png",
    "package": "",
    "capacity": "",
    "category": "CUTLERY"
  },
  {
    "id": "product-144",
    "code": "1HWHF1000B",
    "name": "Wrapped Heavy Duty black Fork",
    "price": "25.69",
    "material": "PS",
    "packing": "1000pcs/ctn",
    "dimensions": "",
    "picture": "1HWHF10\r\n00B.png",
    "package": "",
    "capacity": "",
    "category": "CUTLERY"
  },
  {
    "id": "product-145",
    "code": "1HWHS1000B",
    "name": "Wrapped Heavy Duty blackSpoon",
    "price": "25.12",
    "material": "PS",
    "packing": "1000pcs/ctn",
    "dimensions": "",
    "picture": "1HWHS10\r\n00B.png",
    "package": "",
    "capacity": "",
    "category": "CUTLERY"
  },
  {
    "id": "product-146",
    "code": "1HWHK1000B",
    "name": "Wrapped Heavy Duty black Knife",
    "price": "28.65",
    "material": "PS",
    "packing": "1000pcs/ctn",
    "dimensions": "",
    "picture": "1HWHK10\r\n00B.png",
    "package": "",
    "capacity": "",
    "category": "CUTLERY"
  },
  {
    "id": "product-147",
    "code": "31HWPH50B",
    "name": "3 in 1 PP HEAVY Weight Kit FKN PP - BLACK",
    "price": "29.28",
    "material": "PS",
    "packing": "500/set\r\nFork,Knife,Napkin",
    "dimensions": "",
    "picture": "31HWPH5\r\n0B.png",
    "package": "",
    "capacity": "",
    "category": "CUTLERY"
  },
  {
    "id": "product-148",
    "code": "41HWPH400",
    "name": "4 in 1 PP HEAVY Weight Kit FKSN PP - BLACK",
    "price": "36.65",
    "material": "PS",
    "packing": "500/set\r\nFork,Knife,Spoon,Napkin",
    "dimensions": "",
    "picture": "41HWPH4\r\n00.png",
    "package": "",
    "capacity": "",
    "category": "CUTLERY"
  },
  {
    "id": "product-149",
    "code": "WIDN6M",
    "name": "White Interfold Dispenser Napkin  2 ply",
    "price": "26.47",
    "material": "Paper",
    "packing": "6000/ctn",
    "dimensions": "",
    "picture": "WIDN6M.png",
    "package": "",
    "capacity": "",
    "category": "NAPKINS AND NAPKINS BANDS"
  },
  {
    "id": "product-150",
    "code": "KDN6M",
    "name": "Kraft Interfold Dispenser Napkin 2 ply",
    "price": "26.3",
    "material": "Paper",
    "packing": "6000/ctn",
    "dimensions": "",
    "picture": "KDN6M.png",
    "package": "",
    "capacity": "",
    "category": "NAPKINS AND NAPKINS BANDS"
  },
  {
    "id": "product-151",
    "code": "DN3000-DN201502 V",
    "name": "15x17\" White Dinner Napkin - 2 ply",
    "price": "33.09",
    "material": "Paper",
    "packing": "3000/ctn",
    "dimensions": "",
    "picture": "DN3000-\r\nDN201502 V.png",
    "package": "",
    "capacity": "",
    "category": "NAPKINS AND NAPKINS BANDS"
  },
  {
    "id": "product-152",
    "code": "BNB1M",
    "name": "Black Cocktail Napkin  2 ply",
    "price": "37.28",
    "material": "Paper",
    "packing": "3000/ctn",
    "dimensions": "",
    "picture": "BNB1M.png",
    "package": "",
    "capacity": "",
    "category": "NAPKINS AND NAPKINS BANDS"
  },
  {
    "id": "product-153",
    "code": "BEVNAP1 M-W",
    "name": "White Cocktail Napkin 2 ply",
    "price": "24.03",
    "material": "Paper",
    "packing": "3000/ctn",
    "dimensions": "",
    "picture": "BEVNAP1 M-W.png",
    "package": "",
    "capacity": "",
    "category": "NAPKINS AND NAPKINS BANDS"
  },
  {
    "id": "product-154",
    "code": "Thermal - RR8313",
    "name": "3-1/8’’x220’ 1PLY Thermal Paper Roll",
    "price": "46.25",
    "material": "Paper",
    "packing": "50/ctn",
    "dimensions": "3-1/8’’x200’ 1PLY",
    "picture": "Thermal - RR8313.png",
    "package": "",
    "capacity": "",
    "category": "REGISTER ROLLS"
  },
  {
    "id": "product-155",
    "code": "21/4x50",
    "name": "2 1/4\" x 50' Thermal Paper Roll",
    "price": "16.25",
    "material": "Paper",
    "packing": "50/ctn",
    "dimensions": "2 1/4\" x 50'\r\n1PLY",
    "picture": "21/4x50.png",
    "package": "",
    "capacity": "",
    "category": "REGISTER ROLLS"
  },
  {
    "id": "product-156",
    "code": "3x165-1PLY",
    "name": "3\" x 165' 1-Ply Bond Receipt Paper",
    "price": "35",
    "material": "Paper",
    "packing": "50/ctn",
    "dimensions": "3-1/8’’x200’ 1PLY",
    "picture": "3x165-\r\n1PLY.png",
    "package": "",
    "capacity": "",
    "category": "REGISTER ROLLS"
  },
  {
    "id": "product-157",
    "code": "3x95-2PLY",
    "name": "3\" x 95' 2-Ply Bond Paper",
    "price": "51.25",
    "material": "Paper",
    "packing": "50/ctn",
    "dimensions": "3-1/8’’x200’ 2PLY",
    "picture": "3x95-2PLY.png",
    "package": "",
    "capacity": "",
    "category": "REGISTER ROLLS"
  },
  {
    "id": "product-158",
    "code": "73012",
    "name": "Vinyl Powder Free  Gloves (S)",
    "price": "18.77",
    "material": "Vinyl",
    "packing": "1000/ctn",
    "dimensions": "S",
    "picture": "73012.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-159",
    "code": "73013",
    "name": "Vinyl Powder Free  Gloves (M)",
    "price": "18.77",
    "material": "Vinyl",
    "packing": "1000/ctn",
    "dimensions": "M",
    "picture": "73013.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-160",
    "code": "73014",
    "name": "Vinyl Powder Free  Gloves (L)",
    "price": "18.77",
    "material": "Vinyl",
    "packing": "1000/ctn",
    "dimensions": "L",
    "picture": "73014.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-161",
    "code": "73015",
    "name": "Vinyl Powder Free  Gloves (XL)",
    "price": "18.77",
    "material": "Vinyl",
    "packing": "1000/ctn",
    "dimensions": "XL",
    "picture": "73015.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-162",
    "code": "73022",
    "name": "Vinyl Powdered Gloves (S)",
    "price": "18.77",
    "material": "Vinyl",
    "packing": "1000/ctn",
    "dimensions": "S",
    "picture": "73022.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-163",
    "code": "73023",
    "name": "Vinyl Powdered Gloves (M)",
    "price": "18.77",
    "material": "Vinyl",
    "packing": "1000/ctn",
    "dimensions": "M",
    "picture": "73023.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-164",
    "code": "73024",
    "name": "Vinyl Powdered  Gloves (L)",
    "price": "18.77",
    "material": "Vinyl",
    "packing": "1000/ctn",
    "dimensions": "L",
    "picture": "73024.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-165",
    "code": "73025",
    "name": "Vinyl Powdered Gloves (XL)",
    "price": "18.77",
    "material": "Vinyl",
    "packing": "1000/ctn",
    "dimensions": "XL",
    "picture": "73025.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-166",
    "code": "FP-GT1036",
    "name": "Thermoplastic Elastomer Powder-Free Glove (S)",
    "price": "12.26",
    "material": "Thermo- plastic",
    "packing": "1000/ctn",
    "dimensions": "S",
    "picture": "FP-GT1036.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-167",
    "code": "FP-GT1037",
    "name": "Thermoplastic Elastomer Powder-Free Glove (M)",
    "price": "12.26",
    "material": "Thermo- plastic",
    "packing": "1000/ctn",
    "dimensions": "M",
    "picture": "FP-GT1037.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-168",
    "code": "FP-GT1038",
    "name": "Thermoplastic Elastomer Powder-Free Glove (L)",
    "price": "12.26",
    "material": "Thermo- plastic",
    "packing": "1000/ctn",
    "dimensions": "L",
    "picture": "FP-GT1038.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-169",
    "code": "FP-GT1039",
    "name": "Thermoplastic Elastomer Powder-Free Glove (XL)",
    "price": "12.26",
    "material": "Thermo- plastic",
    "packing": "1000/ctn",
    "dimensions": "XL",
    "picture": "FP-GT1039.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-170",
    "code": "75032",
    "name": "Nitrile Regular Duty Powder Free Gloves (S)",
    "price": "31.86",
    "material": "Nitrile",
    "packing": "1000/ctn",
    "dimensions": "S",
    "picture": "75032.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-171",
    "code": "75033",
    "name": "Nitrile Regular Duty Powder Free Gloves (M)",
    "price": "27.88",
    "material": "Nitrile",
    "packing": "1000/ctn",
    "dimensions": "M",
    "picture": "75033.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-172",
    "code": "75034",
    "name": "Nitrile Regular Duty Powder Free Gloves (L)",
    "price": "27.88",
    "material": "Nitrile",
    "packing": "1000/ctn",
    "dimensions": "L",
    "picture": "75034.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-173",
    "code": "75035",
    "name": "Nitrile Regular Duty Powder Free Gloves (XL)",
    "price": "27.88",
    "material": "Nitrile",
    "packing": "1000/ctn",
    "dimensions": "XL",
    "picture": "75035.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-174",
    "code": "SP-20090",
    "name": "Black Nitrile Blend Gloves Medium",
    "price": "23.29",
    "material": "Nitrile",
    "packing": "1000/ctn",
    "dimensions": "M",
    "picture": "SP-20090.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-175",
    "code": "SP-20091",
    "name": "Black Nitrile Blend Gloves Large",
    "price": "23.29",
    "material": "Nitrile",
    "packing": "1000/ctn",
    "dimensions": "L",
    "picture": "SP-20091.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-176",
    "code": "SP-20092",
    "name": "Black Nitrile Blend Gloves Extra Large",
    "price": "23.29",
    "material": "Nitrile",
    "packing": "1000/ctn",
    "dimensions": "XL",
    "picture": "SP-20092.png",
    "package": "",
    "capacity": "",
    "category": "GLOVES"
  },
  {
    "id": "product-177",
    "code": "SP WS7 - EMP-011",
    "name": "Jumbo Fiber Straw Individually Wrapped",
    "price": "60",
    "material": "Natural Pulp",
    "packing": "2500/ctn",
    "dimensions": "8.3''x0.30'' Jumbo",
    "picture": "SP WS7 - EMP-011.png",
    "package": "",
    "capacity": "",
    "category": "STRAWS"
  },
  {
    "id": "product-178",
    "code": "EMP-011- BLK",
    "name": "Black Jumbo Fiber Straw Individually Wrapped",
    "price": "60",
    "material": "Natural Pulp",
    "packing": "2500/ctn",
    "dimensions": "8.3''x0.30'' Jumbo",
    "picture": "EMP-011- BLK.png",
    "package": "",
    "capacity": "",
    "category": "STRAWS"
  },
  {
    "id": "product-179",
    "code": "EMP-030",
    "name": "Biodegradable Vegetable Fiber Straw (wrapped)",
    "price": "53.33",
    "material": "Natural Pulp",
    "packing": "2500/ctn",
    "dimensions": "7.75''x0.30'' Jumbo",
    "picture": "EMP-030.png",
    "package": "",
    "capacity": "",
    "category": "STRAWS"
  },
  {
    "id": "product-180",
    "code": "EMP-016",
    "name": "5.5’’ Short Fiber Straw Unwrapped",
    "price": "130.67",
    "material": "Natural Pulp",
    "packing": "10 000/ctn",
    "dimensions": "5.6''x0.23''",
    "picture": "EMP-016.png",
    "package": "",
    "capacity": "",
    "category": "STRAWS"
  },
  {
    "id": "product-181",
    "code": "EMP-020",
    "name": "Regular Fiber Straw Individually Unwrapped",
    "price": "46.67",
    "material": "Natural Pulp",
    "packing": "2500/ctn",
    "dimensions": "8.3''x0.23''",
    "picture": "EMP-020.png",
    "package": "",
    "capacity": "",
    "category": "STRAWS"
  },
  {
    "id": "product-182",
    "code": "SP-BOBA",
    "name": "Fiber Boba Straw Unwrapped (Collosal Straws)",
    "price": "206.67",
    "material": "Natural Pulp",
    "packing": "1500/ctn",
    "dimensions": "8.25''x 0.40'' 'Colossal Straws",
    "picture": "SP-BOBA.png",
    "package": "",
    "capacity": "",
    "category": "STRAWS"
  },
  {
    "id": "product-183",
    "code": "Biost-0003",
    "name": "Bioplastic Straw Individually Wrapped",
    "price": "19",
    "material": "Bioplastic",
    "packing": "2000/ctn",
    "dimensions": "7.5''x0.23'' Regular size",
    "picture": "Biost-0003.png",
    "package": "",
    "capacity": "",
    "category": "STRAWS"
  },
  {
    "id": "product-184",
    "code": "SP SC5- EMP0002",
    "name": "Fiber Cocktail Stirrer Unwrapped",
    "price": "125",
    "material": "Natural Pulp",
    "packing": "10,000/ctn",
    "dimensions": "5.5''x0.20'' Regular Size",
    "picture": "SP SC5- EMP0002.png",
    "package": "",
    "capacity": "",
    "category": "COFFEE AND COCKTAIL STIRRERS"
  },
  {
    "id": "product-185",
    "code": "THANK -SMILET- SAK",
    "name": "Thank you Plastic Bags 14 Mic (Heavy Duty)",
    "price": "12.56",
    "material": "Plastic",
    "packing": "500",
    "dimensions": "15x12x6''",
    "picture": "THANK -\r\nSMILET- SAK.png",
    "package": "",
    "capacity": "",
    "category": "PLASTIC BAGS"
  },
  {
    "id": "product-186",
    "code": "THW1A",
    "name": "Thank you Plastic Bags 12.5 Mic",
    "price": "20.96",
    "material": "Plastic",
    "packing": "1000",
    "dimensions": "15x12x6''",
    "picture": "THW1A.png",
    "package": "",
    "capacity": "",
    "category": "PLASTIC BAGS"
  },
  {
    "id": "product-187",
    "code": "#2 Bag",
    "name": "2lb Kraft paper bag SOS Bag",
    "price": "7.89",
    "material": "Kraft Paper",
    "packing": "500/cs",
    "dimensions": "4x2.5x8''",
    "picture": "#2 Bag.png",
    "package": "",
    "capacity": "",
    "category": "NON-HANDLE PAPER BAGS"
  },
  {
    "id": "product-188",
    "code": "#4 Bag",
    "name": "4lb Kraft paper bag SOS Bag",
    "price": "9.1",
    "material": "Kraft Paper",
    "packing": "500/cs",
    "dimensions": "5x3x10''",
    "picture": "#4 Bag.png",
    "package": "",
    "capacity": "",
    "category": "NON-HANDLE PAPER BAGS"
  },
  {
    "id": "product-189",
    "code": "#6 Bag",
    "name": "6lb Kraft paper bag SOS Bag",
    "price": "13.2",
    "material": "Kraft Paper",
    "packing": "500/cs",
    "dimensions": "6x3.5x11''",
    "picture": "#6 Bag.png",
    "package": "",
    "capacity": "",
    "category": "NON-HANDLE PAPER BAGS"
  },
  {
    "id": "product-190",
    "code": "#8 Bag",
    "name": "8lb Kraft paper bag SOS Bag",
    "price": "16.07",
    "material": "Kraft Paper",
    "packing": "500/cs",
    "dimensions": "6.25x4x12.5''",
    "picture": "#8 Bag.png",
    "package": "",
    "capacity": "",
    "category": "NON-HANDLE PAPER BAGS"
  },
  {
    "id": "product-191",
    "code": "#12 Bag",
    "name": "12lb Kraft paper bag SOS Bag",
    "price": "21.17",
    "material": "Kraft Paper",
    "packing": "500/cs",
    "dimensions": "7x13.75x4.5",
    "picture": "#12 Bag.png",
    "package": "",
    "capacity": "",
    "category": "NON-HANDLE PAPER BAGS"
  },
  {
    "id": "product-192",
    "code": "25lb Bag",
    "name": "25lb Kraft Paper Bag SOS Bag",
    "price": "29.57",
    "material": "Kraft Paper",
    "packing": "500/cs",
    "dimensions": "8x5.5x17.5''",
    "picture": "25lb Bag.png",
    "package": "",
    "capacity": "",
    "category": "NON-HANDLE PAPER BAGS"
  },
  {
    "id": "product-193",
    "code": "#1/6 BBLBag",
    "name": "1/6 BBL Kraft Paper Barrel Sack",
    "price": "31.23",
    "material": "Kraft Paper",
    "packing": "250/cs",
    "dimensions": "11.5x7x16''",
    "picture": "#1/6 BBL\r\nBag.png",
    "package": "",
    "capacity": "",
    "category": "NON-HANDLE PAPER BAGS"
  },
  {
    "id": "product-194",
    "code": "#1/8 PPGBag",
    "name": "1/8 BBL Short Kraft Paper Barrel Sack",
    "price": "43.38",
    "material": "Kraft Paper",
    "packing": "500/cs",
    "dimensions": "10x14.4x7\"",
    "picture": "#1/8 PPG\r\nBag.png",
    "package": "",
    "capacity": "",
    "category": "NON-HANDLE PAPER BAGS"
  },
  {
    "id": "product-195",
    "code": "#20lb Bag",
    "name": "20lb.Duro Shorty Brown Paper Bag",
    "price": "30.23",
    "material": "Kraft Paper",
    "packing": "500/cs",
    "dimensions": "8.25x13.4x6''",
    "picture": "#20lb Bag.png",
    "package": "",
    "capacity": "",
    "category": "NON-HANDLE PAPER BAGS"
  },
  {
    "id": "product-196",
    "code": "PB10513Kraft",
    "name": "Small Shopping Paper Bag 10x5x13''   Kraft Color",
    "price": "29.1",
    "material": "Kraft Paper",
    "packing": "250/cs",
    "dimensions": "10x5x12''",
    "picture": "PB10513\r\nKraft.png",
    "package": "",
    "capacity": "",
    "category": "PAPER BAGS WITH HANDLE"
  },
  {
    "id": "product-197",
    "code": "PB10714Kraft",
    "name": "Medium Shopping Paper Bag 10x6.75x13’’Kraft Color",
    "price": "33.02",
    "material": "Kraft Paper",
    "packing": "250/cs",
    "dimensions": "10x6.75x13’'",
    "picture": "PB10714\r\nKraft.png",
    "package": "",
    "capacity": "",
    "category": "PAPER BAGS WITH HANDLE"
  },
  {
    "id": "product-198",
    "code": "PB13671358 Kraft",
    "name": "Senior ShoppingPaper  Bag 13x6.75x13.5’’ Kraft Color",
    "price": "36.1",
    "material": "Kraft Paper",
    "packing": "250/cs",
    "dimensions": "13x6.75x13.5’’",
    "picture": "PB1367135\r\n8 Kraft.png",
    "package": "",
    "capacity": "",
    "category": "PAPER BAGS WITH HANDLE"
  },
  {
    "id": "product-199",
    "code": "PB12717Kraft",
    "name": "Large Shopping Paper Bag 12x7x17'’Kraft Color",
    "price": "40.45",
    "material": "Kraft Paper",
    "packing": "250/cs",
    "dimensions": "12x7.0x17.0''",
    "picture": "PB12717\r\nKraft.png",
    "package": "",
    "capacity": "",
    "category": "PAPER BAGS WITH HANDLE"
  },
  {
    "id": "product-200",
    "code": "PB12915Kraft",
    "name": "Wide Shopping Paper Bag 12x9x15’’Kraft Color",
    "price": "34.74",
    "material": "Kraft Paper",
    "packing": "200/cs",
    "dimensions": "12 x 9 x15 ’’",
    "picture": "PB12915\r\nKraft.png",
    "package": "",
    "capacity": "",
    "category": "PAPER BAGS WITH HANDLE"
  },
  {
    "id": "product-201",
    "code": "PB141015Kraft",
    "name": "Super Jumbo Shopping Paper Bag  14x10x15.75'’Kraft Color",
    "price": "36.88",
    "material": "Kraft Paper",
    "packing": "200/cs",
    "dimensions": "12x7.0x17.0''",
    "picture": "PB141015\r\nKraft.png",
    "package": "",
    "capacity": "",
    "category": "PAPER BAGS WITH HANDLE"
  },
  {
    "id": "product-202",
    "code": "SP- CFOLD",
    "name": "12x10’’ C-Fold Standard Weight Towel 2400/CASE",
    "price": "22.37",
    "material": "Paper",
    "packing": "12/cs",
    "dimensions": "22.37",
    "picture": "SP- CFOLD.png",
    "package": "",
    "capacity": "",
    "category": "PAPER CLEANING SUPPLIES"
  },
  {
    "id": "product-203",
    "code": "M- WHITE2",
    "name": "MULTIFOLD WHITE 4000/CASE",
    "price": "34.29",
    "material": "Paper",
    "packing": "6/cs",
    "dimensions": "34.29",
    "picture": "M- WHITE2.png",
    "package": "",
    "capacity": "",
    "category": "PAPER CLEANING SUPPLIES"
  },
  {
    "id": "product-204",
    "code": "P-RT800",
    "name": "ROLL TOWEL WHITE 8\"X800 SHEET 6 ROLLS /CASE",
    "price": "24.64",
    "material": "Paper",
    "packing": "6/cs",
    "dimensions": "24.64",
    "picture": "P-RT800.png",
    "package": "",
    "capacity": "",
    "category": "PAPER CLEANING SUPPLIES"
  },
  {
    "id": "product-205",
    "code": "75000",
    "name": "Wipe Roll 6”x8” Sheets, 300/Roll, 6/Case",
    "price": "30.71",
    "material": "Plastic",
    "packing": "1/cs",
    "dimensions": "30.71",
    "picture": "75000.png",
    "package": "",
    "capacity": "",
    "category": "PAPER CLEANING SUPPLIES"
  },
  {
    "id": "product-206",
    "code": "24801",
    "name": "1 Gallon bucket with lid, Red wipe dispensing orifice",
    "price": "9.09",
    "material": "Plastic",
    "packing": "200/cs",
    "dimensions": "9.09",
    "picture": "24801.png",
    "package": "",
    "capacity": "",
    "category": "PAPER CLEANING SUPPLIES"
  },
  {
    "id": "product-207",
    "code": "242408",
    "name": "HD liners 24\"x24\" 8 mic  Natural 1000 Ct 10 Gal",
    "price": "22.04",
    "material": "Plastic",
    "packing": "1000/cs",
    "dimensions": "22.04",
    "picture": "242408.png",
    "package": "",
    "capacity": "",
    "category": "CAN LINERS/TRASH BAGS"
  },
  {
    "id": "product-208",
    "code": "24330W",
    "name": "HD liners 24\"x33\" 8 mic  Natural 1000 Ct 12-16 Gal",
    "price": "31.87",
    "material": "Plastic",
    "packing": "500/cs",
    "dimensions": "31.87",
    "picture": "24330W.png",
    "package": "",
    "capacity": "",
    "category": "CAN LINERS/TRASH BAGS"
  },
  {
    "id": "product-209",
    "code": "P4015XC",
    "name": "HD liners 33X39 45 Mil Natural 250 Ct 33 Gal",
    "price": "18.16",
    "material": "Plastic",
    "packing": "250/cs",
    "dimensions": "18.16",
    "picture": "P4015XC.png",
    "package": "",
    "capacity": "",
    "category": "CAN LINERS/TRASH BAGS"
  },
  {
    "id": "product-210",
    "code": "43483W",
    "name": "HD liners 43\"x48\" 16 mic  Natural 200 Ct 45 Gal",
    "price": "30.67",
    "material": "Plastic",
    "packing": "100/cs",
    "dimensions": "30.67",
    "picture": "43483W.png",
    "package": "",
    "capacity": "",
    "category": "CAN LINERS/TRASH BAGS"
  },
  {
    "id": "product-211",
    "code": "MR38603 MC",
    "name": "HD Liners 38\"x58\" Natural 16 Mic- 200 Ct 60 Gal",
    "price": "33.81",
    "material": "Plastic",
    "packing": "100/cs",
    "dimensions": "33.81",
    "picture": "MR38603 MC.png",
    "package": "",
    "capacity": "",
    "category": "CAN LINERS/TRASH BAGS"
  },
  {
    "id": "product-212",
    "code": "MT601XW",
    "name": "HD Liners 38x58,.75 Mil,Natural - 100 Ct 60 Gal",
    "price": "18.70",
    "material": "Plastic",
    "packing": "100/cs",
    "dimensions": "18.7",
    "picture": "MT601XW.png",
    "package": "",
    "capacity": "",
    "category": "CAN LINERS/TRASH BAGS"
  },
  {
    "id": "product-213",
    "code": "RX4433X G",
    "name": "Slim fit LD Liners 29\"x44\" 1.25 Mil Grey 100 Ct   29 Gal",
    "price": "16.03",
    "material": "Plastic",
    "packing": "100/cs",
    "dimensions": "16.03",
    "picture": "RX4433X G.png",
    "package": "",
    "capacity": "",
    "category": "CAN LINERS/TRASH BAGS"
  },
  {
    "id": "product-214",
    "code": "333915",
    "name": "LD Liners 33\"x39\" 1.5 Mil Black 100 Ct   33 Gal",
    "price": "17.51",
    "material": "Plastic",
    "packing": "250/cs",
    "dimensions": "17.51",
    "picture": "333915.png",
    "package": "",
    "capacity": "",
    "category": "CAN LINERS/TRASH BAGS"
  },
  {
    "id": "product-215",
    "code": "385815",
    "name": "LD Liners 38\"x58\" 1.5 Mil Black 100 Ct  60 Gal",
    "price": "27.00",
    "material": "Plastic",
    "packing": "100/cs",
    "dimensions": "27",
    "picture": "385815.png",
    "package": "",
    "capacity": "",
    "category": "CAN LINERS/TRASH BAGS"
  },
  {
    "id": "product-216",
    "code": "385820",
    "name": "LD Liners 38\"x58\" 2.0 Mil Black 100 Ct  60 Gal",
    "price": "32.86",
    "material": "Plastic",
    "packing": "100/cs",
    "dimensions": "32.86",
    "picture": "385820.png",
    "package": "",
    "capacity": "",
    "category": "CAN LINERS/TRASH BAGS"
  },
  {
    "id": "product-217",
    "code": "404615",
    "name": "LD Liners 40\"x46\" 1.5 Mil Black 100 Ct  45 Gal",
    "price": "18.07",
    "material": "Plastic",
    "packing": "250/cs",
    "dimensions": "18.07",
    "picture": "404615.png",
    "package": "",
    "capacity": "",
    "category": "CAN LINERS/TRASH BAGS"
  },
  {
    "id": "product-218",
    "code": "404620",
    "name": "LD Liners 40\"x46\" 2.0 Mil Black 100 Ct  45 Gal",
    "price": "27.47",
    "material": "Plastic",
    "packing": "100/cs",
    "dimensions": "27.47",
    "picture": "404620.png",
    "package": "",
    "capacity": "",
    "category": "CAN LINERS/TRASH BAGS"
  },
  {
    "id": "product-219",
    "code": "4HPC",
    "name": "4 oz. single wall hot cup",
    "price": "44.24",
    "material": "Paper",
    "packing": "2000",
    "dimensions": "20 x 50",
    "picture": "4HPC.png",
    "package": "20 x 50",
    "capacity": "",
    "category": "PAPER CUPS HOT DRINKS"
  },
  {
    "id": "product-220",
    "code": "8HPC",
    "name": "8 oz. single wall hot cup",
    "price": "38.81",
    "material": "Paper",
    "packing": "1000",
    "dimensions": "20 x 50",
    "picture": "8HPC.png",
    "package": "20 x 50",
    "capacity": "",
    "category": "PAPER CUPS HOT DRINKS"
  },
  {
    "id": "product-221",
    "code": "10HPC",
    "name": "10 oz. single wall hot cup",
    "price": "44.26",
    "material": "Paper",
    "packing": "1000",
    "dimensions": "20 x 50",
    "picture": "10HPC.png",
    "package": "20 x 50",
    "capacity": "",
    "category": "PAPER CUPS HOT DRINKS"
  },
  {
    "id": "product-222",
    "code": "12HPC",
    "name": "12 oz. single wall hot cup",
    "price": "47.89",
    "material": "Paper",
    "packing": "1000",
    "dimensions": "20 x 50",
    "picture": "12HPC.png",
    "package": "20 x 50",
    "capacity": "",
    "category": "PAPER CUPS HOT DRINKS"
  },
  {
    "id": "product-223",
    "code": "16HPC",
    "name": "16 oz. single wall hot cup",
    "price": "51.5",
    "material": "Paper",
    "packing": "1000",
    "dimensions": "20 x 50",
    "picture": "16HPC.png",
    "package": "20 x 50",
    "capacity": "",
    "category": "PAPER CUPS HOT DRINKS"
  },
  {
    "id": "product-224",
    "code": "SP- LC08WH",
    "name": "8oz. White Paper Cup Travel Lid with Hinged Tab",
    "price": "28.66",
    "material": "PP",
    "packing": "1000",
    "dimensions": "10 x 100",
    "picture": "SP- LC08WH.png",
    "package": "10 x 100",
    "capacity": "",
    "category": "PAPER CUPS HOT DRINKS"
  },
  {
    "id": "product-225",
    "code": "SP- LC08BK",
    "name": "8oz. Black Paper Cup Travel Lid with Hinged Tab",
    "price": "28.66",
    "material": "PP",
    "packing": "1000",
    "dimensions": "10 x 100",
    "picture": "SP- LC08BK.png",
    "package": "10 x 100",
    "capacity": "",
    "category": "PAPER CUPS HOT DRINKS"
  },
  {
    "id": "product-226",
    "code": "SP-LC1216WSHP-",
    "name": "10oz - 16oz oz. White Paper Cup Travel Lid with Hinged Tab",
    "price": "33.71",
    "material": "PP",
    "packing": "1000",
    "dimensions": "10 x 100",
    "picture": "SP-\r\nLC1216W\r\nSHP-.png",
    "package": "10 x 100",
    "capacity": "",
    "category": "PAPER CUPS HOT DRINKS"
  },
  {
    "id": "product-227",
    "code": "LC1216B K",
    "name": "10oz - 16oz oz. Black Paper Cup Travel Lid with Hinged Tab",
    "price": "33.71",
    "material": "PP",
    "packing": "1000",
    "dimensions": "10 x 100",
    "picture": "LC1216B K.png",
    "package": "10 x 100",
    "capacity": "",
    "category": "PAPER CUPS HOT DRINKS"
  },
  {
    "id": "product-228",
    "code": "SP-PAP76",
    "name": "16oz White Paper Scoop (Fries) Cup",
    "price": "59.8",
    "material": "Paper",
    "packing": "1000",
    "dimensions": "20x50",
    "picture": "SP-PAP76.png",
    "package": "",
    "capacity": "",
    "category": "PAPER FRENCH FRY CUPS"
  },
  {
    "id": "product-229",
    "code": "SP- FO6x55",
    "name": "6x5 White Foam Square Take Out Container",
    "price": "16.89",
    "material": "Foam",
    "packing": "500 pcs",
    "dimensions": "6\"x5\"x3\"",
    "picture": "SP- FO6x55.png",
    "package": "",
    "capacity": "",
    "category": "FOAM TAKEOUT CONTAINERS"
  },
  {
    "id": "product-230",
    "code": "SP-FO6x9X",
    "name": "6x9 White Eco Foam Take Out Container",
    "price": "22.41",
    "material": "Foam",
    "packing": "200 pcs",
    "dimensions": "6\"x5\"x3\"",
    "picture": "SP-\r\nFO6x9X.png",
    "package": "",
    "capacity": "",
    "category": "FOAM TAKEOUT CONTAINERS"
  },
  {
    "id": "product-231",
    "code": "SP- FO8x80",
    "name": "8x8 White Foam Square Take Out Container",
    "price": "16.29",
    "material": "Foam",
    "packing": "200 pcs",
    "dimensions": "8\"x8\"x3\"",
    "picture": "SP- FO8x80.png",
    "package": "",
    "capacity": "",
    "category": "FOAM TAKEOUT CONTAINERS"
  },
  {
    "id": "product-232",
    "code": "SP-FO8x8",
    "name": "8x8-3compartment  White Foam Square Take Out Container",
    "price": "16.29",
    "material": "Foam",
    "packing": "200 pcs",
    "dimensions": "8\"x8\"x3\"",
    "picture": "SP-FO8x8.png",
    "package": "",
    "capacity": "",
    "category": "FOAM TAKEOUT CONTAINERS"
  },
  {
    "id": "product-233",
    "code": "SP-FO9x9",
    "name": "9x9 White Foam Square Take Out Container",
    "price": "21.43",
    "material": "Foam",
    "packing": "200 pcs",
    "dimensions": "9\"x9\"x3\"",
    "picture": "SP-FO9x9.png",
    "package": "",
    "capacity": "",
    "category": "FOAM TAKEOUT CONTAINERS"
  },
  {
    "id": "product-234",
    "code": "SP-FO9x9",
    "name": "9x9-3compartment  White Foam Square Take Out Container",
    "price": "21.43",
    "material": "Foam",
    "packing": "200 pcs",
    "dimensions": "9\"x9\"x3\"",
    "picture": "SP-FO9x9.png",
    "package": "",
    "capacity": "",
    "category": "FOAM TAKEOUT CONTAINERS"
  },
  {
    "id": "product-235",
    "code": "FIORI- 00244",
    "name": "Green Heavy Duty Scour Pads - 6 packs of 8 scour pads each- 48 pcs",
    "price": "54.00",
    "material": "Paper",
    "packing": "1000/cs",
    "dimensions": "54",
    "picture": "FIORI- 00244.png",
    "package": "",
    "capacity": "",
    "category": "SCRUBBERS AND SPONGES"
  },
  {
    "id": "product-236",
    "code": "FIORI- 00273",
    "name": "Long Lasting Stainless Steel Scrubber -72 pcs",
    "price": "67.50",
    "material": "Paper",
    "packing": "1000/cs",
    "dimensions": "67.5",
    "picture": "FIORI- 00273.png",
    "package": "",
    "capacity": "",
    "category": "SCRUBBERS AND SPONGES"
  },
  {
    "id": "product-237",
    "code": "FIOR - 00243",
    "name": "Stainless Steel Scrubber-24 packs of 3  scrubber each -72 pcs",
    "price": "67.50",
    "material": "Paper",
    "packing": "1000/cs",
    "dimensions": "67.5",
    "picture": "FIOR - 00243.png",
    "package": "",
    "capacity": "",
    "category": "SCRUBBERS AND SPONGES"
  },
  {
    "id": "product-238",
    "code": "FIOR- 00232",
    "name": "Sponge With Medium Scouring - 20 packs of 3 sponge each -60 pcs",
    "price": "56.25",
    "material": "Paper",
    "packing": "1000/cs",
    "dimensions": "56.25",
    "picture": "FIOR- 00232.png",
    "package": "",
    "capacity": "",
    "category": "SCRUBBERS AND SPONGES"
  },
  {
    "id": "product-239",
    "code": "W-PALL",
    "name": "Pallet Wrap Film",
    "price": "42.50",
    "material": "Plastic",
    "packing": "4/cs",
    "dimensions": "42.5",
    "picture": "W-PALL.png",
    "package": "",
    "capacity": "",
    "category": "WAREHOUSE SUPPLIES"
  }
];

// Helper exports for backward compatibility
export const productMap = new Map<string, Product>(
  catalogueData.map(p => [p.id, p])
);

export const productCatalogue = productMap;

export const categories = [
  "KRAFT FOLDED TAKEOUT BOX",
  "CLAMSHELL TAKE-OUT BOX",
  "KRAFT FOOD TRAY",
  "MINERAL POWDER CLAMSHELLS",
  "MINERAL POWDER  PLATES",
  "BLACK PLASTIC CONTAINERS",
  "BLACK SUSHI  TRAYS",
  "DUAL COLOR BLACK CONTAINERS",
  "DUAL COLOR BLACK/CLEAR CLAMSHELLS",
  "CLEAR CLAMSHELL",
  "TRANSLUCID PP CLAMSHELL",
  "TAMPER-EVIDENT HINGED CONTAINER",
  "PLASTIC DELI CONTAINER",
  "PAPER KRAFT CONTAINER",
  "PAPER FOOD CONTAINER/PAPER SOUP CUP",
  "PORTION/SOUFFLE CUPS",
  "CLEAR DRINKING CUPS AND LIDS",
  "CUTLERY",
  "NAPKINS AND NAPKINS BANDS",
  "REGISTER ROLLS",
  "GLOVES",
  "STRAWS",
  "COFFEE AND COCKTAIL STIRRERS",
  "PLASTIC BAGS",
  "NON-HANDLE PAPER BAGS",
  "PAPER BAGS WITH HANDLE",
  "PAPER CLEANING SUPPLIES",
  "CAN LINERS/TRASH BAGS",
  "PAPER CUPS HOT DRINKS",
  "PAPER FRENCH FRY CUPS",
  "FOAM TAKEOUT CONTAINERS",
  "SCRUBBERS AND SPONGES",
  "WAREHOUSE SUPPLIES"
];

export function getProductsByCategory(category: string): Product[] {
  return catalogueData.filter(p => p.category === category);
}

export function searchProducts(query: string): Product[] {
  const lowerQuery = query.toLowerCase();
  return catalogueData.filter(
    p =>
      p.code.toLowerCase().includes(lowerQuery) ||
      p.name.toLowerCase().includes(lowerQuery) ||
      p.category.toLowerCase().includes(lowerQuery)
  );
}
